// extracted by mini-css-extract-plugin
module.exports = {"backArrow":"MenuToggle_backArrow__2FPVq","menuClose":"MenuToggle_menuClose__24JuG"};